module.exports = __webpack_public_path__ + "img/renwu1@2x.9be60900.png";